import type { ClientKind } from '@/kinds/kind'
import { apply, defaults, displayName, initialStatus, validate } from './apply'
import { grantSpec, grantStatus, type GrantSpec, type GrantStatus } from './schema'

const Nothing = () => null

/** Grants have no list row or detail of their own: Settings → Sharing renders them. */
export const grantKind: ClientKind<GrantSpec, GrantStatus> = {
  name: 'Grant',
  version: 1,
  spec: grantSpec,
  status: grantStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  actions: ['revoke', 'use', 'download', 'drop'],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: false,
}

export * from './schema'
export type { GrantResource } from './apply'
export { hashSecret, isClientKey, isLive, newSecret } from './apply'
